export default __webpack_public_path__ + "static/media/mr_mrs_smith_logo.ae5af2c8.svg";